export default class ReportQuery {

    public static EmailReport = `mutation EmailReportQuery($input: EmailReportInput!) {
            emailReport(input: $input) {
                success
            }
        }`;
}